// @flow
import React from 'react';
import EmptyState from '../products/empty-state/EmptyStateComponent';

type Props = {
  actions: Object,
  config: {
    permissions: Array<string>,
    contacts: Object,
  },
};

const AccessoriesRestrictedView = ({ actions, config }: Props) => {
  // These props are needed in order for the Empty State Component to be in the right state
  // due to the complexity of that component.
  const requiredEmptyStateProps = {
    actions,
    productTypeId: '',
    productSizesAvailable: {},
    productSize: 'ALL',
    template: 'ALL',
    searchTerm: '',
  };

  return (
    <EmptyState
      isAccessoriesView
      permissions={config.permissions}
      contacts={config.contacts}
      {...requiredEmptyStateProps}
    />
  );
};

AccessoriesRestrictedView.displayName = 'AccessoriesRestrictedView';

export default AccessoriesRestrictedView;
